module.exports = __webpack_public_path__ + "static/media/branch-detail-960.a04ff99f.jpg";